import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ProfileForm } from "@/components/profile/ProfileForm";
import { PrivacyCard } from "@/components/profile/PrivacyCard";
import { LanguageCard } from "@/components/profile/LanguageCard";
import { FutureWavesCard } from "@/components/profile/FutureWavesCard";
import { ResetProfileDialog } from "@/components/profile/ResetProfileDialog";
import { LegalLinksCard } from "@/components/profile/LegalLinksCard";
import { BlockedUsersCard } from "@/components/profile/BlockedUsersCard";
import { useProfile } from "@/context/ProfileContext";
import { useLanguage } from "@/i18n/LanguageContext";
import { fadeUp } from "@/lib/motion";

export default function ProfilePage() {
  const navigate = useNavigate();
  const { profile, updateProfile, clearProfile } = useProfile();
  const { t } = useLanguage();

  const handleReset = () => {
    clearProfile();
    navigate("/onboarding", { replace: true });
  };

  // Phase 9: after successful SERVER-SIDE deletion, unlink the device too
  const handleDeleted = () => {
    clearProfile();
    navigate("/onboarding", { replace: true });
  };

  return (
    <div className="space-y-4">
      <motion.header {...fadeUp(0)} className="pt-2">
        <p className="text-xs uppercase tracking-[0.22em] text-cyan-300/70 font-medium">
          {t("profile.kicker")}
        </p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">
          {t("profile.title")}
        </h1>
      </motion.header>

      <motion.div {...fadeUp(0.06)}>
        <ProfileForm profile={profile} onSave={updateProfile} />
      </motion.div>

      <motion.div {...fadeUp(0.1)}>
        <PrivacyCard
          privacy={profile.privacy}
          onToggle={(privacy) => updateProfile({ privacy })}
        />
      </motion.div>

      <motion.div {...fadeUp(0.14)}>
        <LanguageCard />
      </motion.div>

      {/* Phase 10 (UGC): manage blocked community members */}
      <motion.div {...fadeUp(0.16)}>
        <BlockedUsersCard profileId={profile.id} />
      </motion.div>

      <motion.div {...fadeUp(0.18)}>
        <FutureWavesCard />
      </motion.div>

      <motion.div {...fadeUp(0.22)}>
        <LegalLinksCard profileId={profile.id} onDeleted={handleDeleted} />
      </motion.div>

      <motion.div {...fadeUp(0.26)} className="pt-1 pb-2 flex justify-center">
        <ResetProfileDialog onConfirm={handleReset} />
      </motion.div>
    </div>
  );
}
